import { NgModule } from '@angular/core';

import { ApNotificationComponent } from '@ap/notification';
import { ApChatBubbleComponent } from '@ap/chat-bubble';
import { ApIllustrationComponent } from '@ap/illustration';
import { ApParagraphSkeletonComponent, ApSkeletonComponent } from '@ap/skeleton';
import { ApContentPipe, ApContentService } from '@ap/content';

import { ConversationalChatContainerModule } from './conversational-chat-container/conversational-chat-container.module';
import { ConversationalChatInputModule } from './conversational-chat-input/conversational-chat-input.module';
import { ConversationalChatMessageModule } from './conversational-chat-message/conversational-chat-message.module';
import { KlantConversationalComponent } from './klant-conversational.component';
import { ConversationalChatDisclaimerModule } from './conversational-chat-disclaimer/conversational-chat-disclaimer.module';

/**
 * @ngdoc module
 * @name KlantConversationalModule
 **/
@NgModule({
    declarations: [KlantConversationalComponent],
    imports: [
        ConversationalChatMessageModule,
        ConversationalChatContainerModule,
        ConversationalChatInputModule,
        ConversationalChatDisclaimerModule,
        ApChatBubbleComponent,
        ApContentPipe,
        ApIllustrationComponent,
        ApNotificationComponent,
        ApParagraphSkeletonComponent,
        ApSkeletonComponent
    ],
    exports: [KlantConversationalComponent],
    providers: [ApContentService]
})
export class KlantConversationalModule {}
